import pdfMake from 'pdfmake/build/pdfmake'
import { useState } from 'react'
import { Col, Container, Form, Row, Table } from 'react-bootstrap'
import {
  FileEarmarkPdfFill,
  PersonFillGear,
  Search,
} from 'react-bootstrap-icons'
import { CustomButton } from '../../components/CustomButton'
import { CustomInputDate } from '../../components/CustomInputDate'
import { ModalFuncionarios } from '../../components/ModalFuncionarios'
import Navbar from '../../components/navbar/navbar'
import { useOrdenation } from '../../hooks/useOrdenation'
import apinode from '../../services/apinode'
import { formatDate } from '../../utils/formatDate'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { unifyParams } from '../../utils/unifyParams'
import './styles.css'

export function RelatorioSeparacaoPorData() {
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [type, setType] = useState('sku')
  const [searchTerm, setSearchTerm] = useState('')
  const [isModalConferenteOpen, setIsModalConferenteOpen] = useState(false)
  const [selectedConferente, setSelectedConferente] = useState({})
  const [isSearchLoading, setIsSearchLoading] = useState(false)
  const [results, setResults] = useState([])

  const {
    filteredItems,
    Th,
    Paginate,
    itemsPerPage,
    setItemsPerPage,
    sortedItems,
  } = useOrdenation(results, 'data_conf', 'desc', '25')

  async function handleSearch() {
    try {
      setIsSearchLoading(true)

      const url = unifyParams(
        `/relatorio/separacao-por-data/${localStorage.idconta}`,
        [
          {
            key: 'start_date',
            value: startDate,
          },
          {
            key: 'end_date',
            value: endDate,
          },
          {
            key: 'type',
            value: type,
          },
          {
            key: 'search',
            value: searchTerm,
          },
          {
            key: 'id_conferente',
            value: selectedConferente.IDFUNCIONARIO,
          },
        ],
      )

      const response = await apinode.get(url)

      setResults(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao realizar a busca')
    } finally {
      setIsSearchLoading(false)
    }
  }

  // Configurar fontes do pdfMake (adicione no início do arquivo, antes da função)
  pdfMake.fonts = {
    Roboto: {
      normal:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
      bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
      italics:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Italic.ttf',
      bolditalics:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-MediumItalic.ttf',
    },
  }

  function handleGenerateReport() {
    // Formatar data para exibição
    const formatarData = (dataISO) => {
      const data = new Date(dataISO)
      return data.toLocaleDateString('pt-BR')
    }

    // Calcular total de pedidos
    const totalPedidos = sortedItems.reduce(
      (acc, item) => acc + item.total_pedidos,
      0,
    )

    // Preparar dados da tabela com cores alternadas
    const dadosTabela = sortedItems.map((item, index) => [
      {
        text: formatarData(item.data_conf),
        alignment: 'left',
        margin: [10, 8, 0, 8],
        fontSize: 9,
        fillColor: index % 2 === 0 ? '#FFFFFF' : '#F8FAFC',
        border: [false, false, false, false],
      },
      {
        text: item.total_pedidos.toString(),
        alignment: 'center',
        bold: true,
        color: '#0F172A',
        fontSize: 9,
        fillColor: index % 2 === 0 ? '#FFFFFF' : '#F8FAFC',
        margin: [0, 8, 10, 8],
        border: [false, false, false, false],
      },
    ])

    // Definir estrutura do documento
    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 100, 40, 70],

      header: (currentPage, pageCount) => ({
        margin: [40, 30, 40, 0],
        stack: [
          {
            columns: [
              {
                width: '*',
                stack: [
                  {
                    text: 'ZipHub',
                    style: 'headerTitle',
                    color: '#0F172A',
                  },
                  {
                    text: `${localStorage.username} - ${localStorage.nomeconta}`,
                    style: 'headerSubtitle',
                  },
                ],
              },
              {
                width: 'auto',
                stack: [
                  {
                    text: `Página ${currentPage}/${pageCount}`,
                    alignment: 'right',
                    fontSize: 9,
                    color: '#64748B',
                    margin: [0, 5, 0, 0],
                  },
                ],
              },
            ],
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 10,
                x2: 515,
                y2: 10,
                lineWidth: 2,
                lineColor: '#E2E8F0',
              },
            ],
            margin: [0, 10, 0, 0],
          },
        ],
      }),

      footer: () => ({
        margin: [40, 20, 40, 0],
        stack: [
          {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
                lineColor: '#E2E8F0',
              },
            ],
          },
          {
            text: `Relatório gerado em ${new Date().toLocaleString('pt-BR')}`,
            alignment: 'center',
            fontSize: 8,
            color: '#94A3B8',
            margin: [0, 10, 0, 0],
          },
        ],
      }),

      content: [
        // Card de Título
        {
          stack: [
            {
              text: 'Relatório de Separação',
              style: 'titulo',
              margin: [0, 10, 0, 10],
            },
            {
              text: 'Análise por Data',
              fontSize: 14,
              color: '#64748B',
              alignment: 'center',
              margin: [0, 0, 0, 25],
            },
          ],
        },

        // Card de Filtros - Design Moderno
        {
          table: {
            widths: ['*'],
            body: [
              [
                {
                  stack: [
                    {
                      text: 'FILTROS APLICADOS',
                      fontSize: 10,
                      bold: true,
                      color: '#475569',
                      letterSpacing: 1,
                      margin: [0, 0, 0, 12],
                    },
                    {
                      columns: [
                        {
                          width: '50%',
                          stack: [
                            {
                              text: 'Período',
                              fontSize: 9,
                              color: '#94A3B8',
                              margin: [0, 0, 0, 4],
                            },
                            {
                              text: `${formatDate(startDate) || '-'} até ${formatDate(endDate) || '-'}`,
                              fontSize: 11,
                              color: '#0F172A',
                              bold: true,
                            },
                          ],
                        },
                        {
                          width: '50%',
                          stack: [
                            {
                              text: 'Tipo',
                              fontSize: 9,
                              color: '#94A3B8',
                              margin: [0, 0, 0, 4],
                            },
                            {
                              text: type === 'descricao' ? 'Descrição' : 'SKU',
                              fontSize: 11,
                              color: '#0F172A',
                              bold: true,
                            },
                          ],
                        },
                      ],
                      margin: [0, 0, 0, 12],
                    },
                    {
                      columns: [
                        {
                          width: '50%',
                          stack: [
                            {
                              text: 'Pesquisa',
                              fontSize: 9,
                              color: '#94A3B8',
                              margin: [0, 0, 0, 4],
                            },
                            {
                              text:
                                `"${searchTerm}"` || 'Nenhum filtro aplicado',
                              fontSize: 11,
                              color: '#0F172A',
                              bold: true,
                            },
                          ],
                        },
                        {
                          width: '50%',
                          stack: [
                            {
                              text: 'Conferente',
                              fontSize: 9,
                              color: '#94A3B8',
                              margin: [0, 0, 0, 4],
                            },
                            {
                              text: selectedConferente.NOMEFUNCIONARIO,
                              fontSize: 11,
                              color: '#0F172A',
                              bold: true,
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  fillColor: '#F8FAFC',
                  border: [false, false, false, false],
                  margin: [20, 15, 20, 15],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingLeft: () => 0,
            paddingRight: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0,
          },
          margin: [0, 0, 0, 25],
        },

        // Label da Tabela
        {
          text: 'DETALHAMENTO POR DATA',
          fontSize: 10,
          bold: true,
          color: '#475569',
          letterSpacing: 1,
          margin: [0, 0, 0, 12],
        },

        // Tabela de dados - Design Clean
        {
          table: {
            headerRows: 1,
            widths: ['*', 120],
            body: [
              // Cabeçalho
              [
                {
                  text: 'Data',
                  style: 'tableHeader',
                  alignment: 'left',
                  margin: [10, 12, 0, 12],
                },
                {
                  text: 'Total de Pedidos',
                  style: 'tableHeader',
                  alignment: 'center',
                  margin: [0, 12, 10, 12],
                },
              ],
              // Dados
              ...dadosTabela,
            ],
          },
          layout: {
            hLineWidth: (i) => {
              if (i === 0) return 0
              if (i === 1) return 2
              return 0
            },
            vLineWidth: () => 0,
            hLineColor: (i) => (i === 1 ? '#E2E8F0' : '#E2E8F0'),
            paddingLeft: () => 0,
            paddingRight: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0,
          },
          margin: [0, 0, 0, 20],
        },

        // Total Final - Card Destacado
        {
          table: {
            widths: ['*'],
            body: [
              [
                {
                  columns: [
                    {
                      width: '*',
                      text: 'TOTAL GERAL',
                      fontSize: 13,
                      bold: true,
                      color: '#0F172A',
                      alignment: 'right',
                      margin: [0, 10, 20, 10],
                    },
                    {
                      width: 120,
                      text: totalPedidos.toString(),
                      fontSize: 18,
                      bold: true,
                      color: '#3B82F6',
                      alignment: 'center',
                      margin: [0, 8, 0, 8],
                    },
                  ],
                  border: [false, false, false, false],
                  fillColor: '#F1F5F9',
                },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingLeft: () => 0,
            paddingRight: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0,
          },
        },
      ],

      styles: {
        headerTitle: {
          fontSize: 20,
          bold: true,
          color: '#0F172A',
        },
        headerSubtitle: {
          fontSize: 9,
          color: '#64748B',
          marginTop: 4,
        },
        titulo: {
          fontSize: 24,
          bold: true,
          alignment: 'center',
          color: '#0F172A',
        },
        tableHeader: {
          bold: true,
          fontSize: 10,
          color: '#475569',
          fillColor: '#F1F5F9',
          letterSpacing: 0.5,
        },
      },

      defaultStyle: {
        fontSize: 10,
        font: 'Roboto',
        lineHeight: 1.3,
      },
    }

    // Gerar PDF
    pdfMake.createPdf(docDefinition).open()
  }

  return (
    <>
      <Navbar />

      <Container className="mt-page p-4">
        <h1>Relatório Separação por Data</h1>

        <Row className="mb-3">
          <Col xs={2}>
            <Form.Label>De</Form.Label>

            <CustomInputDate
              selected={startDate}
              onChange={setStartDate}
            />
          </Col>

          <Col xs={2}>
            <Form.Label>Até</Form.Label>

            <CustomInputDate
              selected={endDate}
              onChange={setEndDate}
            />
          </Col>

          <Col xs={2}>
            <Form.Label>Tipo</Form.Label>

            <Form.Select
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="sku">SKU</option>
              <option value="descricao">Descrição</option>
            </Form.Select>
          </Col>

          <Col xs={2}>
            <Form.Label>Produto</Form.Label>

            <Form.Control
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Digite aqui"
            />
          </Col>

          <Col>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                height: '100%',
              }}
            >
              <CustomButton
                title={
                  selectedConferente?.IDFUNCIONARIO
                    ? `${selectedConferente?.NOMEFUNCIONARIO}`
                    : 'Selec. Conferente'
                }
                onClick={() => setIsModalConferenteOpen(true)}
              >
                <PersonFillGear size={20} />
              </CustomButton>

              <CustomButton
                title="Buscar"
                isLoadingText="Buscando..."
                onClick={handleSearch}
                isLoading={isSearchLoading}
                isDisabled={
                  !startDate ||
                  !endDate ||
                  !searchTerm ||
                  !selectedConferente?.IDFUNCIONARIO
                }
              >
                <Search size={20} />
              </CustomButton>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={2}>
            <Form.Label>Itens p/ página</Form.Label>
            <Form.Select
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(e.target.value)}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Form.Select>
          </Col>
        </Row>

        {results.length > 0 && (
          <>
            <Table className="relatorio-data">
              <thead>
                <tr>
                  <th colSpan={2}>
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <CustomButton
                        noMargin
                        title="Gerar Relatório"
                        onClick={handleGenerateReport}
                      >
                        <FileEarmarkPdfFill size={20} />
                      </CustomButton>

                      <p
                        style={{
                          all: 'unset',
                        }}
                      >
                        Mostrando {filteredItems.length} de {results.length}
                      </p>
                    </div>
                  </th>
                </tr>

                <tr>
                  <Th
                    value="data_conf"
                    label="Data"
                  />
                  <Th
                    value="total_pedidos"
                    label="Total de Pedidos"
                  />
                </tr>
              </thead>

              <tbody>
                {filteredItems.map((result) => (
                  <tr>
                    <td>{formatDate(result.data_conf)}</td>
                    <td>{result.total_pedidos}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </>
        )}
      </Container>

      <ModalFuncionarios
        isOpen={isModalConferenteOpen}
        onClose={() => setIsModalConferenteOpen(false)}
        onSelectFuncionario={setSelectedConferente}
      />
    </>
  )
}
